import React from 'react';
import { IconYellowCard, IconRedCard, IconGoal } from './components/EventIcons/EventIcons';
import WCEstadisticasPartido from '../WCEstadisticasPartido/WCEstadisticasPartido';
import WCJugadores from '../WCJugadores/WCJugadores';
import WCResumen from '../WCResumen/WCResumen';
import WCAlineaciones from './WCAlineaciones';

/** Orden: [0]=portero, luego líneas desde defensa (portería propia) hacia el ataque. Las posiciones en cancha las calcula `applyFormationToPitchPlayers`. */
export const ARG_PITCH = [
  { name: 'Grillitsch', isHome: true },
  { name: 'Grillitsch', isHome: true },
  { name: 'Grillitsch', yellow: true, isHome: true },
  { name: 'Grillitsch', isHome: true },
  { name: 'Grillitsch', isHome: true },
  { name: 'Grillitsch', goal: true, isHome: true },
  { name: 'Grillitsch', isHome: true, goal: true, goalCount: 4 },
  { name: 'Grillitsch', isHome: true, yellow: true, subOut: true },
  { name: 'Grillitsch', isHome: true, red: true },
  {
    name: 'Grillitsch',
    isHome: true,
    redCard2y: true,
    subOut: true,
    goal: true,
    goalCount: 4,
  },
  { name: 'Grillitsch', isHome: true },
];

export const AUT_PITCH = [
  { name: 'Grillitsch', isHome: false },
  { name: 'Grillitsch', isHome: false },
  { name: 'Grillitsch', isHome: false },
  { name: 'Grillitsch', isHome: false },
  { name: 'Grillitsch', isHome: false },
  { name: 'Grillitsch', yellow: true, isHome: false },
  { name: 'Grillitsch', goal: true, isHome: false },
  { name: 'Grillitsch', isHome: false, goal: true, goalCount: 2 },
  { name: 'Grillitsch', isHome: false, yellow: true, subOut: true },
  { name: 'Grillitsch', isHome: false, red: true },
  {
    name: 'Grillitsch',
    isHome: false,
    redCard2y: true,
    subOut: true,
    goal: true,
    goalCount: 2,
  },
];

export const STARTER_ROWS = [
  { eventsHome: [], eventsAway: [] },
  { eventsHome: [<IconYellowCard key="y" />], eventsAway: [] },
  { eventsHome: [<IconGoal key="g" n={2} />], eventsAway: [] },
  { eventsHome: [<IconRedCard key="r" />], eventsAway: [] },
  {
    eventsHome: [],
    eventsAway: [],
    subHome: "↓ 90' Entra: Nico Paz",
  },
  { eventsHome: [], eventsAway: [] },
  { eventsHome: [], eventsAway: [] },
  { eventsHome: [], eventsAway: [] },
  { eventsHome: [], eventsAway: [] },
  { eventsHome: [], eventsAway: [] },
  { eventsHome: [], eventsAway: [] },
];

export const BENCH_ROWS = [
  { eventsHome: [], eventsAway: [], subAway: "↑ 85' Sale: Nico Paz" },
  { eventsHome: [], eventsAway: [] },
  { eventsHome: [], eventsAway: [] },
];

export {
  parseFormationString,
  normalizeFormationOrDefault,
  invertFormationStringForAway,
  buildDesktopPitchPositions,
  applyFormationToPitchPlayers,
  buildMobileVerticalRows,
} from './utils/formationUtils';

export const WCA_LINEACIONES_TAB_IDS = {
  ESTADISTICAS: 'estadisticas',
  JUGADORES: 'jugadores',
  RESUMEN: 'resumen',
  ALINEACIONES: 'alineaciones',
};

export const WCA_LINEACIONES_TABS = [
  {
    id: WCA_LINEACIONES_TAB_IDS.ESTADISTICAS,
    label: 'Estadísticas del partido',
    Component: WCEstadisticasPartido,
  },
  {
    id: WCA_LINEACIONES_TAB_IDS.JUGADORES,
    label: 'Jugadores',
    Component: WCJugadores,
  },
  {
    id: WCA_LINEACIONES_TAB_IDS.RESUMEN,
    label: 'Resumen',
    Component: WCResumen,
  },
  {
    id: WCA_LINEACIONES_TAB_IDS.ALINEACIONES,
    label: 'Alineaciones',
    Component: WCAlineaciones,
  },
];
